import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'articles';

export const articlesService = {
  // Получить все статьи
  async getAllArticles() {
    try {
      const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting articles:', error);
      throw error;
    }
  },

  // Получить статью по ID
  async getArticleById(id) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      } else {
        throw new Error('Article not found');
      }
    } catch (error) {
      console.error('Error getting article:', error);
      throw error;
    }
  },

  // Создать новую статью
  async createArticle(articleData) {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...articleData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        views: 0,
        author: 'Администратор'
      });
      return docRef.id;
    } catch (error) {
      console.error('Error creating article:', error);
      throw error;
    }
  },

  // Обновить статью
  async updateArticle(id, articleData) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        ...articleData,
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error updating article:', error);
      throw error;
    }
  },

  // Удалить статью
  async deleteArticle(id) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await deleteDoc(docRef);
    } catch (error) {
      console.error('Error deleting article:', error);
      throw error;
    }
  }
};
